import type { JSX } from 'react'
import type { ToastActionProps } from './types'
import { useLink } from '@/hooks/useLink'
import { cn } from '@ttab/elephant-ui/utils'

export const ToastActionButton = ({
  documentId,
  planningId,
  withView,
  Icon,
  label,
  target = 'last'
}: ToastActionProps): JSX.Element | null => {
  const openDocument = useLink(withView)

  if (!documentId) {
    return null
  }

  return (
    <button
      type='button'
      className={cn(
        'flex flex-1 h-9 items-center justify-center gap-2 cursor-pointer transition-all',
        'text-xs opacity-60 hover:opacity-100 hover:bg-current/5',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset',
        'focus-visible:ring-ring'
      )}
      onClick={(event) => openDocument(event, { id: documentId, planningId }, target)}
    >
      <Icon size={16} strokeWidth={1.75} aria-hidden />
      {label}
    </button>
  )
}
